import { Plan2 } from "types/plan.type";

export const initialState = {
  plans: [],
  yearlyPlan: new Plan2({})
};
